<template>
  <div id="app">
    <!-- 主路由视图 -->
    <router-view />

    <!-- 全局加载状态指示器（可选） -->
    <div v-if="loading" class="global-loading">
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      loading: false
    }
  },
  mounted() {
    this.checkFontRendering()
    const isChinese = navigator.language.includes('zh')
  document.documentElement.style.setProperty(
    '--main-font',
    isChinese ? '"PingFang SC", "Microsoft YaHei"' : '-apple-system, BlinkMacSystemFont'
  )
},
methods: {
  testFontRender(fontName) {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const text = '字体测试'
    const baseWidth = ctx.measureText(text).width

    ctx.font = `16px ${fontName}, sans-serif`
    const testWidth = ctx.measureText(text).width

    return baseWidth !== testWidth
  },
  forceLoadFont() {
    const style = document.createElement('style')
    style.id = 'font-nuclear'
    style.innerHTML = `
      @font-face {
        font-family: 'ForceFont';
        src: local('Microsoft YaHei'),
             local('PingFang SC'),
             local('SimHei');
      }
      * {
        font-family: 'ForceFont' !important;
      }
    `
    document.head.appendChild(style)
  },
  checkFontRendering() {
    const testElements = [
      { text: '测试字体', className: 'font-test-chinese' },
      { text: 'Test Font', className: 'font-test-english' }
    ]

    testElements.forEach(item => {
      const el = document.createElement('div')
      el.className = item.className
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      el.style.visibility = 'hidden'
      el.textContent = item.text
      document.body.appendChild(el)
    })

    setTimeout(() => {
      console.log('字体渲染测试元素已添加')
    }, 1000)
  }

}

}
</script>

<style scoped>
/* 全局加载动画样式（可选） */
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>